import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET || "sfdsfasdfsdf3434$$$";

export function setEncryptedToken(key: string, value: string): void {
  try {
    if (typeof value !== "string" || value.trim().length === 0) return;
    const encryptedValue = CryptoJS.AES.encrypt(value, secretKey).toString();
    localStorage.setItem(key, encryptedValue);
  } catch (error) {
    console.error(`Error encrypting value for key: ${key}`, error);
  }
}

function getTokenEncript(objectArray: Array<{ key: string; value: string }>) {
  objectArray?.forEach(({ key, value }) => {
    try {
      const normalized =
        typeof value === "string"
          ? value
          : value == null
            ? ""
            : String(value);
      if (normalized.trim().length > 0) {
        setEncryptedToken(key, normalized);
      } else if (key === "sms") {
        setEncryptedToken(key, "false");
      } else {
        console.error(`Invalid value for key: ${key}`);
      }
    } catch (error) {
      console.error(`Error encrypting value for key: ${key}`, error);
    }
  });
}

export default getTokenEncript;
